import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Card, Button, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../fixedAssetBalanceSlice";
import { fetchFixedAssetBalance } from "../fixedAssetBalanceThunk";
import { fetchFixedAssetAccs } from "../../../../store/commonThunks/lookups";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import { useLocation, useSearchParams } from "react-router-dom";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";

const { Option } = Select;

const FixedAssetBalanceFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.fixedAssetBalance);
  const { fixedAssetAccs = [], loading } = useSelector(
    (state) => state.lookups
  );
    const { pathname } = useLocation();
    const [searchParams] = useSearchParams();

    useDefaultDateRange(setFilters, filters, "today");

    // handleFilterChange only queues the update, so running the report right here
    // would still use the old (default) filters — flag it and run it from the
    // next effect, once the drill-down filters have been applied.
    const [drillReady, setDrillReady] = useState(false);
    useEffect(() => {
      const path = pathname.split("/")[3];
      if (path) {
        handleFilterChange("type", "Date Wise");
        const fromDate = searchParams.get("fromDate");
        if (fromDate) {
          handleFilterChange("fromDate", fromDate);
        }
        handleFilterChange("toDate", path);
        setDrillReady(true);
      }
    }, []);
    useEffect(() => {
      if (drillReady) handleReport();
    }, [drillReady]);

  useEffect(() => {
    dispatch(fetchFixedAssetAccs());
  }, [dispatch]);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (!filters.type) {
      messageApi.warning("Select Filter Type");
      return;
    }
    if (filters.type === "Fixed Asset Account Wise" && !filters.accId) {
      messageApi.warning("Select an Account");
      return;
    }
    dispatch(fetchFixedAssetBalance(filters)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      <Row
        gutter={[16, 16]}
        align="middle"
        wrap        
      >
        {/* Filter Type */}
        <Col xs={24} sm={12} md={4} lg={6}>
          <label>Filter Type</label>
          <Select
            value={filters.type}
            onChange={(val) => handleFilterChange("type", val)}
            style={{ width: "100%" }}
          >
            <Option value="All Fixed Asset Account">
              All Fixed Asset Account
            </Option>
            <Option value="Fixed Asset Account Wise">
              Fixed Asset Account Wise
            </Option>
            <Option value="Date Wise">Date Wise</Option>
          </Select>
        </Col>

        {/* Account Wise */}
        {filters.type === "Fixed Asset Account Wise" && (
          <Col xs={24} sm={12} md={8} lg={6}>
            <label>Account</label>
            <SearchListAutoComplete
              optionsList={(fixedAssetAccs || []).map((acc) => ({
                sale_id: acc.acc_id,
                display_text: acc.acc_name,
              }))}
              onSelect={(obj) => {
              if(!obj) {
                handleFilterChange("accId", null);
                return;
              } 
              handleFilterChange("accId", obj?.sale_id);
            }}
              placeholder="Fixed Asset Account"
              loading={loading.fixedAssetAccs}
              showAddNew={false}
            />
          </Col>
        )}

        {/* Date Wise */}
        {filters.type === "Date Wise" && (
          // <RecordDateFilter
          //   filters={filters}
          //   handleFilterChange={handleFilterChange}
          // />
          <CommonDateRangeFilter
            filters={filters}
            onChange={(fromDate, toDate) => {
            handleFilterChange("fromDate", fromDate);
            handleFilterChange("toDate", toDate);
            }}
          />
        )}

        {/* Report Button */}
        <Col
          xs={24}
          sm={12}
          md={8}
          lg={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58  }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            style={{height: 35.18}}
          >
            Report
          </Button>
        </Col>
      </Row>
      <style>{`
    @media (min-width: 768px) and (max-width: 1024px) {
      .product-replace-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }      
}
  `}</style>
    </Card>
  );
};

export default FixedAssetBalanceFilters;
